import { insertAndFocus } from 'common/Prose/utils/insertAndFocus'
import { schema } from 'prose-core'
import { type EditorView } from 'prosemirror-view'

export const useDiagramButton = (view: EditorView) => {
  return () => {
    // TODO: Fix this the next time the file is edited.
    // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
    insertAndFocus(view, schema.nodes.mermaid_embed.createAndFill({})!)
  }
}
